import { getSessionSettings } from '@hotjar/webapp/domains/common/session-settings/api';
import type { SessionsSettings } from '@hotjar/webapp/domains/common/session-settings/model';
import type { UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';

export const SESSION_QUERY_KEY = 'session_settings';

export const SESSION_QUERY_CONFIG = {
  staleTime: 60 * 60 * 1000,
  cacheTime: 60 * 60 * 1000,
  refetchOnWindowFocus: false,
};

export const useSessionSettings = (
  siteId: number | undefined,
  enabled = true,
): UseQueryResult<SessionsSettings, Error> =>
  useQuery([SESSION_QUERY_KEY, siteId], () => getSessionSettings(siteId as number), {
    enabled: Boolean(siteId) && enabled,
    ...SESSION_QUERY_CONFIG,
  });
